import type { FC } from 'react';
import { Box, Skeleton } from '@mui/material';

interface CreativesGridSkeletonProps {
  rowCount?: number;
  showGroupHeaders?: boolean;
}

const CreativesGridSkeleton: FC<CreativesGridSkeletonProps> = ({
  rowCount = 6,
  showGroupHeaders = true,
}) => {
  return (
    <Box sx={{ width: '100%' }} role="status" aria-label="Loading test creatives">
      {showGroupHeaders && (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 1.5 }}>
          <Skeleton variant="text" width={90} height={24} />
          <Skeleton variant="rectangular" sx={{ flex: 1, height: 1 }} />
        </Box>
      )}
      <Box
        sx={{
          border: '1px solid',
          borderColor: 'divider',
          borderRadius: 2,
          overflow: 'hidden',
        }}
      >
        {/* group header row */}
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            px: 1.5,
            py: 1,
            borderBottom: '1px solid',
            borderColor: 'divider',
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Skeleton variant="rectangular" width={20} height={20} />
            <Skeleton variant="text" width={180} height={22} />
            <Skeleton variant="text" width={80} height={20} />
          </Box>
          <Skeleton variant="rectangular" width={120} height={32} sx={{ borderRadius: 1 }} />
        </Box>

        {/* rows */}
        {Array.from({ length: rowCount }).map((_, i) => (
          <Box
            key={i}
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 2,
              px: 1.5,
              py: 1.25,
              borderBottom:
                i === rowCount - 1 ? 'none' : '1px solid',
              borderColor: 'divider',
            }}
          >
            <Skeleton variant="rectangular" width={20} height={20} />
            <Skeleton variant="rectangular" width={48} height={36} sx={{ borderRadius: 1 }} />
            <Skeleton variant="text" sx={{ flex: 1 }} height={20} />
            <Skeleton variant="text" width={80} height={20} />
            <Skeleton variant="text" width={80} height={20} />
            <Skeleton variant="text" width={100} height={20} />
            <Skeleton variant="rectangular" width={90} height={24} sx={{ borderRadius: 12 }} />
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default CreativesGridSkeleton;
